import { Component, OnInit, Input } from '@angular/core';
import { EmployeeService } from '../../../../pages/employee/services/employee.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../../core/services/utility.service';

@Component({
  selector: 'app-manage-cat-modal',
  templateUrl: './manage-cat-modal.component.html',
  styleUrls: ['./manage-cat-modal.component.css']
})
export class ManageCatModalComponent implements OnInit {
  formData: { [key: string]: any } = {};
  catList: any;
  lastSave: { [key: string]: any } = {};
  labelFade: any;

  constructor(private utilityService: UtilityService, private employeeService: EmployeeService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.getCat();
  }

  public getCat() {
    this.employeeService.getCategory().then((response: any) => {
      this.catList = response;
    })
  }

  public deleteTrigger(data, type) {
    if (type == "yes")
      data.deleteTrigger = true;
    else
      data.deleteTrigger = false;
  }

  public addCat() {
    this.employeeService.catgAddEdit(-1, this.formData.newName, true).then((response: any) => {
      this.saveLabel(response.success);
      this.formData.newName = null;
      this.getCat();
    })
  }

  public updateCat(data) {
    this.employeeService.catgAddEdit(data.ExpenseCatgID, data.ExpenseCatgName, data.IsActive).then((response: any) => {
      this.saveLabel(response.success);
    })
  }

  public deleteCat(data) {
    this.employeeService.catgDelete(data.ExpenseCatgID).then((response: any) => {
      this.saveLabel(response.success);
      this.getCat();
    })
  }

  public saveLabel(status: boolean) {
    this.labelFade = false;
    this.lastSave = this.utilityService.fadeLabel(status);
    setTimeout(() => {
      this.labelFade = true;
    }, 2000);
  }

  public closeClicked() {
    this.activeModal.close();
  }
}
